import type { GlobalCal, PrefillAndIframeAttrsConfig } from "@calcom/embed-core"
import Cal from "@calcom/embed-react"
import { useEffect } from "react"

interface Props {
  cal: GlobalCal
  namespace: string
  calLink: string
  config: PrefillAndIframeAttrsConfig
  onMeetingScheduled: (event: CustomEvent) => void
}

export default function CalEmbed({ cal, namespace, calLink, config, onMeetingScheduled }: Props) {
  useEffect(() => {
    cal("ui", { hideEventTypeDetails: true, layout: config.layout })
  }, [])

  useEffect(() => {
    cal("on", { action: "bookingSuccessful", callback: onMeetingScheduled })
    return () => cal("off", { action: "bookingSuccessful", callback: onMeetingScheduled })
  }, [onMeetingScheduled])

  return (
    <Cal
      namespace={namespace}
      calLink={calLink}
      style={{ width: "100%", height: "100%", overflow: "scroll" }}
      config={config}
    />
  )
}
